import React, { useRef } from 'react';
// import Hero from './components/Hero/Hero'; // Temporarily disabled
import About from './components/About/About';
import RipplePage from './components/RipplePage/RipplePage';
import Journey from './components/Journey/Journey';
import Projects from './components/Projects/Projects';
import Footer from './components/Footer/Footer';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import FadeInWrapper from './components/ui/FadeInWrapper';
import useResourcePreloader from './hooks/useResourcePreloader';
import usePerformanceMonitor from './hooks/usePerformanceMonitor';
import useAppLoader from './hooks/useAppLoader';

const App = () => {
  const containerRef = useRef(null);
  const { isLoading, setIsLoading } = useAppLoader();

  // Use performance monitoring and resource preloading hooks
  useResourcePreloader();
  usePerformanceMonitor();

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  const handleRippleTransition = () => {
    // Smooth scroll to the next section after the circle enlarges
    if (containerRef.current) {
      const nextSection = containerRef.current.children[1];
      if (nextSection) {
        nextSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  // Show loading screen while app is loading
  if (isLoading) {
    return <LoadingScreen onLoadingComplete={handleLoadingComplete} />;
  }

  return (
    <FadeInWrapper>
      <div ref={containerRef} className="snap-y snap-mandatory h-screen overflow-y-scroll bg-gradient-to-br from-gray-900 via-black to-blue-900">
      {/* Ripple Landing Page - Keep original fonts */}
      <div className="snap-start h-screen">
        <RipplePage onTransition={handleRippleTransition} />
      </div>
      
      {/* About Me Page - Use San Francisco font */}
      <div className="snap-start min-h-screen font-sf">
        <About />
      </div>
      
      {/* My Journey Timeline Page - Use San Francisco font */}
      <div className="snap-start min-h-screen font-sf">
        <Journey />
      </div>
      
      {/* Temporarily hidden - Hero page */}
      {/* <div className="snap-start h-screen bg-white">
        <Hero />
      </div> */}
      
      {/* Temporarily hidden - About/Ripple effect page */}
      {/* <div className="snap-start h-screen bg-gray-50">
        <About />
      </div> */}
      
      <div className="snap-start min-h-screen font-sf">
        <Projects />
      </div>
      
      {/* Footer - Use San Francisco font */}
      <div className="snap-start font-sf">
        <Footer />
      </div>
      </div>
    </FadeInWrapper>
  );
};

export default App;
